<div class="header">
  <spb-logo [routePath]="['base']" title="Aktbevakning"></spb-logo>

  @if (configService.isAdmin()) {
    <div class="menu">
      @if (roleHelper.fileView()) {
        <div class="pointer" [routerLink]="['/base']">Aktvy</div>
      }
      @if (roleHelper.bulkView()) {
        <div class="pointer" [routerLink]="['/base', 'bulk']">Ank. reg.</div>
      }
      @if (roleHelper.fileView()) {
        <div class="pointer" [routerLink]="['/base', 'reports']">Rapporter</div>
      }
    </div>
  }

  <div [style.flex-grow]="1"></div>

  <spb-toggle-button [style.margin-right.px]="10"/>


  @if (configService.currentUser()) {
    <div class="view-name">
      <span>{{ configService.currentUser()?.name }}</span>
      <button
        [style.margin-right.rem]="2"
        [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  }
</div>
<!-- Add other navigations here -->
<mat-menu #menu="matMenu">
  @if (roleHelper.isFMAdmin()) {
    <button [matMenuTriggerFor]="views" mat-menu-item>Vy</button>
  }
  @if (roleHelper.isSimulating()) {
    <button (click)="roleHelper.setView(null)" mat-menu-item>
      Återställ vy
    </button>
  }
  <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
</mat-menu>

<mat-menu #views="matMenu">
  <button
    (click)="roleHelper.setView(INTERNAL_SUPPORT_ROLE)"
    mat-menu-item>
    Internstöd
  </button>
  <button
    (click)="roleHelper.setView(CREDIT_ROLE)"
    mat-menu-item>
    Kredit
  </button>
  <button
    (click)="roleHelper.setView(CUSTOMER_SUPPORT_ROLE)"
    mat-menu-item>
    Kundstöd
  </button>
  <button
    (click)="roleHelper.setView(WATCH_ROLE)"
    mat-menu-item>
    Titta
  </button>
</mat-menu>